/* @flow */

import * as React from 'react';
import { compose } from 'ramda';
import withForwardRef from '@braindate/util/lib/react/hoc/withForwardRef';

import Button, { VARIANT } from 'src/shared/ui/component/button/Button';

import type { Props as ButtonProps } from 'src/shared/ui/component/button/Button';

const PrimaryButton = (props: ButtonProps): React.Node => (
  <Button {...props} variant={VARIANT.PRIMARY} />
);
export default compose(React.memo, withForwardRef)(PrimaryButton);
